import { createIcon } from '@chakra-ui/react'

export const ListIcon = createIcon({
  displayName: 'ListIcon',
  viewBox: '0 0 24 24',
  path: (
    <path d='M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01' stroke='currentColor' strokeWidth='1.75' strokeLinecap='round' strokeLinejoin='round' />
  ),
})
